export const PATTERN = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  password: /(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=.*[@#$%._^&+=*!])(?=[^0-9]*[0-9]).{8,24}/,
  name: /(.|\s)*\S(.|\s)*/,
  character: /^[a-zA-Z]/,
  phone: /^[1-9][0-9]*$/,
  price: /(^[0][1-9]+)|([1-9]\d*)+$/,
  alphaNumeric: "^[a-zA-Z0-9]+$",
  alphaNumericWithSpace: /^[a-zA-Z0-9!@#?.,$-%^& ]{0,50}$/,
  alphabetsWithSpace: "^[a-zA-Z!@#?$%^&* ]*$",
  text: /^[a-zA-Z ]+(\s[a-zA-Z ]+)?$/,
  textWithLimit: /^[a-zA-Z '-]{0,50}$/,
  forAll: /^.{1,400}$/,
  empty: /^$|\s+/,
  description: /^[a-zA-Z '-]{0,400}$/,
  url: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
  excludeOnlyZeroes: /([0]*[1-9]{1,6}[0]*)/,
  numberWithLimit: /^[0-9]{1,14}$/,
  anyButDigit: /^[^\d]*$/,
  numberOnly: /[^0-9_]/g,
  htmlRestrict: /(<([^>]+)>)/gi,
  zipCodeRegex: /^\d{5}(?:[-\s]\d{4})?$/,
  // excludeDigits:/\\d/
  excludeDigits: /^[a-zA-Z@~`!@#$%^&*()_=+\\';:"\/?>.<,-]*$/
};
